module.exports = __webpack_public_path__ + "static/media/Floor005-01.e8cc7a43.jpg";